import { useState } from 'react';
import { useStore } from '../store';
import { useT } from './UI';

export default function Login() {
  const theme = useT();
  const { login } = useStore();
  const [user, setUser]   = useState('');
  const [pass, setPass]   = useState('');
  const [err,  setErr]    = useState('');
  const [busy, setBusy]   = useState(false);
  const [showPass, setShowPass] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!user || !pass) return setErr('Introduce usuario y contraseña');
    setBusy(true); setErr('');
    try {
      await login(user, pass);
    } catch(ex) {
      setErr(ex.message || 'Error de conexión con el servidor');
    }
    setBusy(false);
  }

  return (
    <div style={{
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:`linear-gradient(135deg, ${theme.primary} 0%, ${theme.bg} 100%)`, padding:20,
    }}>
      <div style={{
        background:theme.surface, borderRadius:20, padding:'40px 36px', width:'100%', maxWidth:400,
        boxShadow:'0 20px 60px rgba(0,0,0,.35)', border:`1px solid ${theme.border}`,
      }}>
        {/* Logo / cabecera */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{
            width:64, height:64, background:theme.primary, borderRadius:16,
            display:'flex', alignItems:'center', justifyContent:'center',
            fontSize:30, margin:'0 auto 14px',
          }}>💻</div>
          <h1 style={{ fontSize:22, fontWeight:800, color:theme.ink }}>ROOT INFORMATICA</h1>
          <p style={{ fontSize:12, color:theme.faint, marginTop:2 }}>Root Imported Technologies SL</p>
          <p style={{ fontSize:13, color:theme.muted, marginTop:6 }}>Panel de gestión — Acceso privado</p>
        </div>

        <form onSubmit={submit}>
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:12, fontWeight:600, color:theme.body, display:'block', marginBottom:5 }}>
              Usuario
            </label>
            <input
              value={user} onChange={e => setUser(e.target.value)}
              autoComplete="off"
              style={{ width:'100%', padding:'11px 14px', border:`1.5px solid ${theme.borderStrong}`, borderRadius:10, fontSize:14, outline:'none', background:theme.surface2, color:theme.ink }}
            />
          </div>
          <div style={{ marginBottom:20, position:'relative' }}>
            <label style={{ fontSize:12, fontWeight:600, color:theme.body, display:'block', marginBottom:5 }}>
              Contraseña
            </label>
            <input
              type={showPass ? 'text' : 'password'}
              value={pass} onChange={e => setPass(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              style={{ width:'100%', padding:'11px 40px 11px 14px', border:`1.5px solid ${theme.borderStrong}`, borderRadius:10, fontSize:14, outline:'none', background:theme.surface2, color:theme.ink }}
            />
            <button type="button" onClick={() => setShowPass(s => !s)}
              style={{ position:'absolute', right:12, bottom:10, background:'none', border:'none', cursor:'pointer', fontSize:16, color:theme.faint }}>
              {showPass ? '🙈' : '👁️'}
            </button>
          </div>

          {err && (
            <div style={{ background:'#fee2e2', color:'#991b1b', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 }}>
              ⚠️ {err}
            </div>
          )}

          <button type="submit" disabled={busy} style={{
            width:'100%', padding:'13px', background: busy ? theme.faint : theme.primary,
            color: busy ? theme.surface : '#fff', border:'none', borderRadius:10, fontSize:15, fontWeight:700,
            cursor: busy ? 'not-allowed' : 'pointer',
          }}>
            {busy ? 'Conectando...' : 'Entrar'}
          </button>
        </form>

        <p style={{ textAlign:'center', fontSize:11, color:theme.faint, marginTop:20 }}>
          Los datos se guardan en el servidor Node.js
        </p>
      </div>
    </div>
  );
}
